import { AxiosResponse } from 'axios'
import { RequestCDU, RequestREAD } from 'services/Instances'

export const ContractTypeParamsServices = () => {
  const path = 'TipoContrato'
  const create = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/Create`, requestObj)

  const patch = async (
    requestObj: IContractTypeParams
  ): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/Update`, requestObj)

  const del = async (id: number): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path}/Delete?id=${id}`)

  const getAll = async (): Promise<AxiosResponse<IContractTypeParams[]>> =>
    await RequestREAD.get(path)

  const get = async (id: number): Promise<AxiosResponse<IContractTypeParams>> =>
    await RequestREAD.get(`${path}/${id}`)

  return { create, del, get, getAll, patch }
}

export interface IContractTypeParams {
  idTipoContrato?: number
  dsTipoContrato: string
}

export const SectorParamsServices = () => {
  const path = 'SetorContrato'
  const create = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/Create`, requestObj)

  const patch = async (requestObj: ISectorParams): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/Update`, requestObj)

  const deleteSector = async (id: number): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path}/Delete?id=${id}`)

  const getAll = async (): Promise<AxiosResponse<ISectorParams[]>> =>
    await RequestREAD.get(path)

  const get = async (id: number): Promise<AxiosResponse<ISectorParams>> =>
    await RequestREAD.get(`${path}/${id}`)

  return { create, deleteSector, get, getAll, patch }
}

export interface ISectorParams {
  idSetorContrato?: number
  dsSetorContrato: string
}
